// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClinicLocalTime-module__font-s-10___Ylt9x {
  font-size: 10px !important;
}

.ClinicLocalTime-module__font-s-12___XnX3g {
  font-size: 12px !important;
}

.ClinicLocalTime-module__font-s-13___van1s {
  font-size: 13px !important;
}

.ClinicLocalTime-module__font-s-14___TuJGV {
  font-size: 14px !important;
}

.ClinicLocalTime-module__font-s-15___YWIwz {
  font-size: 15px !important;
}

.ClinicLocalTime-module__font-s-16___YxYgy {
  font-size: 16px !important;
}

.ClinicLocalTime-module__font-s-18___Ta1X_ {
  font-size: 18px !important;
}

.ClinicLocalTime-module__font-s-20___yjX3O {
  font-size: 20px !important;
}

.ClinicLocalTime-module__font-s-22___NpYNR {
  font-size: 22px !important;
}

.ClinicLocalTime-module__font-s-28___hx6S5 {
  font-size: 28px !important;
}

.ClinicLocalTime-module__font-w-400___ZTBM8 {
  font-weight: 400 !important;
}

.ClinicLocalTime-module__font-w-500___vZEOA {
  font-weight: 500 !important;
}

.ClinicLocalTime-module__font-w-600___bqUFQ {
  font-weight: 600 !important;
}

.ClinicLocalTime-module__font-w-700___Tzjuj {
  font-weight: 700 !important;
}

.ClinicLocalTime-module__p-5___gwRJS {
  padding: 5px !important;
}

.ClinicLocalTime-module__p-12___CG2p2 {
  padding: 12px !important;
}

.ClinicLocalTime-module__p-16___YksBw {
  padding: 16px !important;
}

.ClinicLocalTime-module__p-30___lIzSj {
  padding: 30px !important;
}

.ClinicLocalTime-module__p-b-0___ZZJoM {
  padding-bottom: 0 !important;
}

.ClinicLocalTime-module__p-b-5___V7q7K {
  padding-bottom: 5px !important;
}

.ClinicLocalTime-module__p-b-10___EwtMe {
  padding-bottom: 10px !important;
}

.ClinicLocalTime-module__p-b-12___jylBX {
  padding-bottom: 12px !important;
}

.ClinicLocalTime-module__p-b-16___T1rZq {
  padding-bottom: 16px !important;
}

.ClinicLocalTime-module__p-b-18___akSto {
  padding-bottom: 18px !important;
}

.ClinicLocalTime-module__p-b-20___oozjD {
  padding-bottom: 20px !important;
}

.ClinicLocalTime-module__p-b-25___koXpp {
  padding-bottom: 25px !important;
}

.ClinicLocalTime-module__p-b-30___OoNz2 {
  padding-bottom: 30px !important;
}

.ClinicLocalTime-module__p-b-50___Nj_F4 {
  padding-bottom: 50px !important;
}

.ClinicLocalTime-module__p-t-0___JmII3 {
  padding-top: 0 !important;
}

.ClinicLocalTime-module__p-t-12___xbcgH {
  padding-top: 12px !important;
}

.ClinicLocalTime-module__p-t-16___wBdAB {
  padding-top: 16px !important;
}

.ClinicLocalTime-module__p-t-18___J_eiS {
  padding-top: 18px !important;
}

.ClinicLocalTime-module__p-t-20___zHPnS {
  padding-top: 20px !important;
}

.ClinicLocalTime-module__p-t-30___hQUoc {
  padding-top: 30px !important;
}

.ClinicLocalTime-module__p-t-40___Ev_m0 {
  padding-top: 40px !important;
}

.ClinicLocalTime-module__p-t-50___kCbHD {
  padding-top: 50px !important;
}

.ClinicLocalTime-module__p-l-20___WZoI2 {
  padding-left: 20px !important;
}

.ClinicLocalTime-module__p-l-30___whBMP {
  padding-left: 30px !important;
}

.ClinicLocalTime-module__p-l-40___FES8q {
  padding-left: 40px !important;
}

.ClinicLocalTime-module__p-r-16___PgMzu {
  padding-right: 16px !important;
}

.ClinicLocalTime-module__p-r-20___NztHe {
  padding-right: 20px !important;
}

.ClinicLocalTime-module__p-r-30___8Xa4_ {
  padding-right: 30px !important;
}

.ClinicLocalTime-module__p-r-50___VJhPd {
  padding-right: 50px !important;
}

.ClinicLocalTime-module__p-r-60___YqxZS {
  padding-right: 60px !important;
}

.ClinicLocalTime-module__m-b-1___i99wW {
  margin-bottom: 1px !important;
}

.ClinicLocalTime-module__m-b-2___hX3r9 {
  margin-bottom: 2px !important;
}

.ClinicLocalTime-module__m-b-6___H34Lt {
  margin-bottom: 6px !important;
}

.ClinicLocalTime-module__m-b-8___MUdJR {
  margin-bottom: 8px !important;
}

.ClinicLocalTime-module__m-b-10___QdWOt {
  margin-bottom: 10px !important;
}

.ClinicLocalTime-module__m-b-14___jJcio {
  margin-bottom: 14px !important;
}

.ClinicLocalTime-module__m-b-16___Gnvjr {
  margin-bottom: 16px !important;
}

.ClinicLocalTime-module__m-b-20___dTltQ {
  margin-bottom: 20px !important;
}

.ClinicLocalTime-module__m-b-22___FZmRt {
  margin-bottom: 22px !important;
}

.ClinicLocalTime-module__m-b-24___fuKSi {
  margin-bottom: 24px !important;
}

.ClinicLocalTime-module__m-b-30___ueqrH {
  margin-bottom: 30px !important;
}

.ClinicLocalTime-module__m-b-32___Lv_mb {
  margin-bottom: 32px !important;
}

.ClinicLocalTime-module__m-b-40___X83Wh {
  margin-bottom: 40px !important;
}

.ClinicLocalTime-module__m-t-2___vy8wA {
  margin-top: 2px !important;
}

.ClinicLocalTime-module__m-t-3___Chzp3 {
  margin-top: 3px !important;
}

.ClinicLocalTime-module__m-t-4___VJQO1 {
  margin-top: 4px !important;
}

.ClinicLocalTime-module__m-t-5___iHji7 {
  margin-top: 5px !important;
}

.ClinicLocalTime-module__m-t-8___QCZYl {
  margin-top: 8px !important;
}

.ClinicLocalTime-module__m-t-10___fbZZH {
  margin-top: 10px !important;
}

.ClinicLocalTime-module__m-t-15___8fjxT {
  margin-top: 15px !important;
}

.ClinicLocalTime-module__m-t-16___loNqY {
  margin-top: 16px !important;
}

.ClinicLocalTime-module__m-t-20___Lyo1e {
  margin-top: 20px !important;
}

.ClinicLocalTime-module__m-t-22___yQ_vg {
  margin-top: 22px !important;
}

.ClinicLocalTime-module__m-t-30___04tVp {
  margin-top: 30px !important;
}

.ClinicLocalTime-module__m-t-32___lZQnG {
  margin-top: 32px !important;
}

.ClinicLocalTime-module__m-l-auto___SLDKv {
  margin-left: auto !important;
}

.ClinicLocalTime-module__m-l-4___A9Qcm {
  margin-left: 4px !important;
}

.ClinicLocalTime-module__m-l-5___PdvDz {
  margin-left: 5px !important;
}

.ClinicLocalTime-module__m-l-6___oJe5I {
  margin-left: 6px !important;
}

.ClinicLocalTime-module__m-l-8___j0oMD {
  margin-left: 8px !important;
}

.ClinicLocalTime-module__m-l-10___KfByI {
  margin-left: 10px !important;
}

.ClinicLocalTime-module__m-l-16___NBmbu {
  margin-left: 16px !important;
}

.ClinicLocalTime-module__m-l-20___jaY_u {
  margin-left: 20px !important;
}

.ClinicLocalTime-module__m-l-24___Dm7ou {
  margin-left: 24px !important;
}

.ClinicLocalTime-module__m-l-30___j5qhi {
  margin-left: 30px !important;
}

.ClinicLocalTime-module__m-l-35___qR4Ra {
  margin-left: 35px !important;
}

.ClinicLocalTime-module__m-l-40___LLWd1 {
  margin-left: 40px !important;
}

.ClinicLocalTime-module__m-r-8___D5Ibr {
  margin-right: 8px !important;
}

.ClinicLocalTime-module__m-r-10___zDdJ5 {
  margin-right: 10px !important;
}

.ClinicLocalTime-module__m-r-16___fP8SK {
  margin-right: 16px !important;
}

.ClinicLocalTime-module__m-r-20___jt297 {
  margin-right: 20px !important;
}

.ClinicLocalTime-module__m-r-24____LfMW {
  margin-right: 24px !important;
}

.ClinicLocalTime-module__m-r-30___tC0JM {
  margin-right: 30px !important;
}

.ClinicLocalTime-module__m-r-40___rfx8z {
  margin-right: 40px !important;
}

.ClinicLocalTime-module__border-r-3___fSflc {
  border-radius: 3px !important;
}

.ClinicLocalTime-module__border-r-4___DiWQH {
  border-radius: 4px !important;
}

.ClinicLocalTime-module__border-r-6___n3oF_ {
  border-radius: 6px !important;
}

.ClinicLocalTime-module__border-r-10___jMXl9 {
  border-radius: 10px !important;
}

.ClinicLocalTime-module__border-r-12___MvmiR {
  border-radius: 12px !important;
}

.ClinicLocalTime-module__border-r-16___M2TZw {
  border-radius: 16px !important;
}

.ClinicLocalTime-module__border-r-50___MHpUC {
  border-radius: 50% !important;
}

.ClinicLocalTime-module__primary-border___iP5Gg {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ClinicLocalTime-module__primary-border-b___pLx6R {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ClinicLocalTime-module__primary-border-t___iwVD8 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ClinicLocalTime-module__primary-border-l___xmcJg {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ClinicLocalTime-module__primary-border-r___Ot7Uh {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ClinicLocalTime-module__secondary-border___XXtbY {
  border: 1px solid #637768;
}

.ClinicLocalTime-module__secondary-border-b___x4xpJ {
  border-bottom: 1px solid #637768;
}

.ClinicLocalTime-module__secondary-border-t___d9Uxf {
  border-top: 1px solid #637768;
}

.ClinicLocalTime-module__secondary-border-l___BlQ5Z {
  border-left: 1px solid #637768;
}

.ClinicLocalTime-module__secondary-border-r___sX8HG {
  border-right: 1px solid #637768;
}

.ClinicLocalTime-module__gap-0___j3W5f {
  gap: 0 !important;
}

.ClinicLocalTime-module__gap-2___i9kYn {
  gap: 2px !important;
}

.ClinicLocalTime-module__gap-4___IfuGn {
  gap: 4px !important;
}

.ClinicLocalTime-module__gap-5___D4B_C {
  gap: 5px !important;
}

.ClinicLocalTime-module__gap-6___I1Pdw {
  gap: 6px !important;
}

.ClinicLocalTime-module__gap-8___A54f6 {
  gap: 8px !important;
}

.ClinicLocalTime-module__gap-10___p9GAa {
  gap: 10px !important;
}

.ClinicLocalTime-module__gap-12___Tt_h5 {
  gap: 12px !important;
}

.ClinicLocalTime-module__gap-14___SmxLi {
  gap: 14px !important;
}

.ClinicLocalTime-module__gap-16___D9lyp {
  gap: 16px !important;
}

.ClinicLocalTime-module__gap-18___n0hGa {
  gap: 18px !important;
}

.ClinicLocalTime-module__gap-20___TGKpF {
  gap: 20px !important;
}

.ClinicLocalTime-module__gap-24___TF35N {
  gap: 24px !important;
}

.ClinicLocalTime-module__gap-26___F5Y9s {
  gap: 26px !important;
}

.ClinicLocalTime-module__gap-30___XFd0t {
  gap: 30px !important;
}

.ClinicLocalTime-module__gap-32___YLvOW {
  gap: 32px !important;
}

.ClinicLocalTime-module__gap-40___flTno {
  gap: 40px !important;
}

.ClinicLocalTime-module__gap-50___QrT_P {
  gap: 50px !important;
}

.ClinicLocalTime-module__flex-1___J4r89 {
  flex: 1;
}

.ClinicLocalTime-module__flex-none____plhT {
  flex: none !important;
}

.ClinicLocalTime-module__flex-column___CAaml {
  display: flex;
  flex-direction: column !important;
}

.ClinicLocalTime-module__flex-row____yWwi {
  display: flex;
  flex-direction: row !important;
}

.ClinicLocalTime-module__vertically-centered___N36H9 {
  display: flex;
  align-items: center !important;
}

.ClinicLocalTime-module__horizontally-centered___yOgTl {
  display: flex;
  justify-content: center !important;
}

.ClinicLocalTime-module__horizontally-end___pdoBw {
  display: flex;
  justify-content: end !important;
}

.ClinicLocalTime-module__vertically-start___e8_S4 {
  display: flex;
  align-items: start !important;
}

.ClinicLocalTime-module__space-between___ePX6P {
  display: flex;
  justify-content: space-between !important;
}

.ClinicLocalTime-module__flex-wrap___LIvwe {
  flex-wrap: wrap !important;
}

.ClinicLocalTime-module__height-100___n3IXE {
  height: 100%;
}

.ClinicLocalTime-module__width-50___bNjO8 {
  width: 50% !important;
}

.ClinicLocalTime-module__width-100___fKm6I {
  width: 100%;
}

.ClinicLocalTime-module__cursor-pointer___Qisji {
  cursor: pointer;
}

.ClinicLocalTime-module__cursor-not-allowed___KgdaI {
  cursor: not-allowed !important;
}

.ClinicLocalTime-module__absolute-centered___lhiNx {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ClinicLocalTime-module__absolute___Rnd22 {
  position: absolute;
}

.ClinicLocalTime-module__relative___N_4pw {
  position: relative;
}

.ClinicLocalTime-module__fixed___gKyz8 {
  position: fixed;
}

.ClinicLocalTime-module__visible___QWROt {
  opacity: 1;
}

.ClinicLocalTime-module__invisible___puo3L {
  opacity: 0;
}

.ClinicLocalTime-module__col-90___aUvBf {
  width: 90% !important;
}

.ClinicLocalTime-module__col-auto___t_HEK {
  width: auto !important;
}

.ClinicLocalTime-module__medical-tabs___O1AGt {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ClinicLocalTime-module__medical-table-new___b0ioy {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ClinicLocalTime-module__medical-table-new___b0ioy:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ClinicLocalTime-module__medical-table-new___b0ioy::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ClinicLocalTime-module__medical-table-new___b0ioy::-webkit-scrollbar-track {
  display: none;
}
.ClinicLocalTime-module__medical-table-new___b0ioy.ClinicLocalTime-module__no-pagination___WirEw {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ClinicLocalTime-module__medical-table-new___b0ioy.ClinicLocalTime-module__no-pagination___WirEw:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ClinicLocalTime-module__medical-table-new___b0ioy.ClinicLocalTime-module__no-pagination___WirEw::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ClinicLocalTime-module__medical-table-new___b0ioy.ClinicLocalTime-module__no-pagination___WirEw::-webkit-scrollbar-track {
  display: none;
}

.ClinicLocalTime-module__medical-table-empty___f17aE {
  padding: 14px 40px !important;
}

.ClinicLocalTime-module__icon-btn___gKKTR {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ClinicLocalTime-module__search-icon___vrH7q {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ClinicLocalTime-module__disable-select___Ls5H6 {
  user-select: none;
}

.ClinicLocalTime-module__break-word___zDXmF {
  word-break: break-word;
}

.ClinicLocalTime-module__popup-clear-btn___yK7Ud {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ClinicLocalTime-module__scroll-m-b-20___Ut0NO {
  scroll-margin-bottom: 20px;
}

.ClinicLocalTime-module__clinicLocal___f42up {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: baseline;
  gap: 0 10px;
  margin: 0;
}
.ClinicLocalTime-module__clinicLocal___f42up dt {
  font-size: 14px;
  color: #3f3f46;
}
.ClinicLocalTime-module__clinicLocal___f42up dd {
  margin: 0;
  line-height: 16px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  color: #71717a;
}

.ClinicLocalTime-module__localLabel___qpWm8 {
  color: #71717a !important;
}

.ClinicLocalTime-module__localTime___M0RGv {
  color: #a1a1aa !important;
}
.ClinicLocalTime-module__localTime___M0RGv span {
  white-space: nowrap;
}

.ClinicLocalTime-module__compact___n9LfR {
  line-height: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 0 12px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  color: #a1a1aa;
}
.ClinicLocalTime-module__compact___n9LfR span {
  white-space: nowrap;
}
.ClinicLocalTime-module__compact___n9LfR b {
  font-weight: 600;
  color: #71717a;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/Visit/ClinicLocalTime.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,0CAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;AA8pBF;AA5pBE;EACE,eAAA;EACA,cAAA;AA8pBJ;AA3pBE;EACE,SAAA;EACA,iBAAA;EACA,uCAAA;EACA,eAAA;EACA,cEZI;AFyqBR;;AAzpBA;EACE,yBAAA;AA4pBF;;AAzpBA;EACE,yBAAA;AA4pBF;AA1pBE;EACE,mBAAA;AA4pBJ;;AAxpBA;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;AA2pBF;AAzpBE;EACE,mBAAA;AA2pBJ;AAxpBE;EACE,gBAAA;EACA,cE3CI;AFqsBR","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.clinicLocal {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: baseline;\n  gap: 0 10px;\n  margin: 0;\n\n  dt {\n    font-size: 14px;\n    color: #3f3f46;\n  }\n\n  dd {\n    margin: 0;\n    line-height: 16px;\n    font-family: 'IBM Plex Mono', monospace;\n    font-size: 12px;\n    color: $label;\n  }\n}\n\n.localLabel {\n  color: $label !important;\n}\n\n.localTime {\n  color: #a1a1aa !important;\n\n  span {\n    white-space: nowrap;\n  }\n}\n\n.compact {\n  line-height: 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 12px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  color: #a1a1aa;\n\n  span {\n    white-space: nowrap;\n  }\n\n  b {\n    font-weight: 600;\n    color: $label;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ClinicLocalTime-module__font-s-10___Ylt9x`,
	"fontS12": `ClinicLocalTime-module__font-s-12___XnX3g`,
	"fontS13": `ClinicLocalTime-module__font-s-13___van1s`,
	"fontS14": `ClinicLocalTime-module__font-s-14___TuJGV`,
	"fontS15": `ClinicLocalTime-module__font-s-15___YWIwz`,
	"fontS16": `ClinicLocalTime-module__font-s-16___YxYgy`,
	"fontS18": `ClinicLocalTime-module__font-s-18___Ta1X_`,
	"fontS20": `ClinicLocalTime-module__font-s-20___yjX3O`,
	"fontS22": `ClinicLocalTime-module__font-s-22___NpYNR`,
	"fontS28": `ClinicLocalTime-module__font-s-28___hx6S5`,
	"fontW400": `ClinicLocalTime-module__font-w-400___ZTBM8`,
	"fontW500": `ClinicLocalTime-module__font-w-500___vZEOA`,
	"fontW600": `ClinicLocalTime-module__font-w-600___bqUFQ`,
	"fontW700": `ClinicLocalTime-module__font-w-700___Tzjuj`,
	"p5": `ClinicLocalTime-module__p-5___gwRJS`,
	"p12": `ClinicLocalTime-module__p-12___CG2p2`,
	"p16": `ClinicLocalTime-module__p-16___YksBw`,
	"p30": `ClinicLocalTime-module__p-30___lIzSj`,
	"pB0": `ClinicLocalTime-module__p-b-0___ZZJoM`,
	"pB5": `ClinicLocalTime-module__p-b-5___V7q7K`,
	"pB10": `ClinicLocalTime-module__p-b-10___EwtMe`,
	"pB12": `ClinicLocalTime-module__p-b-12___jylBX`,
	"pB16": `ClinicLocalTime-module__p-b-16___T1rZq`,
	"pB18": `ClinicLocalTime-module__p-b-18___akSto`,
	"pB20": `ClinicLocalTime-module__p-b-20___oozjD`,
	"pB25": `ClinicLocalTime-module__p-b-25___koXpp`,
	"pB30": `ClinicLocalTime-module__p-b-30___OoNz2`,
	"pB50": `ClinicLocalTime-module__p-b-50___Nj_F4`,
	"pT0": `ClinicLocalTime-module__p-t-0___JmII3`,
	"pT12": `ClinicLocalTime-module__p-t-12___xbcgH`,
	"pT16": `ClinicLocalTime-module__p-t-16___wBdAB`,
	"pT18": `ClinicLocalTime-module__p-t-18___J_eiS`,
	"pT20": `ClinicLocalTime-module__p-t-20___zHPnS`,
	"pT30": `ClinicLocalTime-module__p-t-30___hQUoc`,
	"pT40": `ClinicLocalTime-module__p-t-40___Ev_m0`,
	"pT50": `ClinicLocalTime-module__p-t-50___kCbHD`,
	"pL20": `ClinicLocalTime-module__p-l-20___WZoI2`,
	"pL30": `ClinicLocalTime-module__p-l-30___whBMP`,
	"pL40": `ClinicLocalTime-module__p-l-40___FES8q`,
	"pR16": `ClinicLocalTime-module__p-r-16___PgMzu`,
	"pR20": `ClinicLocalTime-module__p-r-20___NztHe`,
	"pR30": `ClinicLocalTime-module__p-r-30___8Xa4_`,
	"pR50": `ClinicLocalTime-module__p-r-50___VJhPd`,
	"pR60": `ClinicLocalTime-module__p-r-60___YqxZS`,
	"mB1": `ClinicLocalTime-module__m-b-1___i99wW`,
	"mB2": `ClinicLocalTime-module__m-b-2___hX3r9`,
	"mB6": `ClinicLocalTime-module__m-b-6___H34Lt`,
	"mB8": `ClinicLocalTime-module__m-b-8___MUdJR`,
	"mB10": `ClinicLocalTime-module__m-b-10___QdWOt`,
	"mB14": `ClinicLocalTime-module__m-b-14___jJcio`,
	"mB16": `ClinicLocalTime-module__m-b-16___Gnvjr`,
	"mB20": `ClinicLocalTime-module__m-b-20___dTltQ`,
	"mB22": `ClinicLocalTime-module__m-b-22___FZmRt`,
	"mB24": `ClinicLocalTime-module__m-b-24___fuKSi`,
	"mB30": `ClinicLocalTime-module__m-b-30___ueqrH`,
	"mB32": `ClinicLocalTime-module__m-b-32___Lv_mb`,
	"mB40": `ClinicLocalTime-module__m-b-40___X83Wh`,
	"mT2": `ClinicLocalTime-module__m-t-2___vy8wA`,
	"mT3": `ClinicLocalTime-module__m-t-3___Chzp3`,
	"mT4": `ClinicLocalTime-module__m-t-4___VJQO1`,
	"mT5": `ClinicLocalTime-module__m-t-5___iHji7`,
	"mT8": `ClinicLocalTime-module__m-t-8___QCZYl`,
	"mT10": `ClinicLocalTime-module__m-t-10___fbZZH`,
	"mT15": `ClinicLocalTime-module__m-t-15___8fjxT`,
	"mT16": `ClinicLocalTime-module__m-t-16___loNqY`,
	"mT20": `ClinicLocalTime-module__m-t-20___Lyo1e`,
	"mT22": `ClinicLocalTime-module__m-t-22___yQ_vg`,
	"mT30": `ClinicLocalTime-module__m-t-30___04tVp`,
	"mT32": `ClinicLocalTime-module__m-t-32___lZQnG`,
	"mLAuto": `ClinicLocalTime-module__m-l-auto___SLDKv`,
	"mL4": `ClinicLocalTime-module__m-l-4___A9Qcm`,
	"mL5": `ClinicLocalTime-module__m-l-5___PdvDz`,
	"mL6": `ClinicLocalTime-module__m-l-6___oJe5I`,
	"mL8": `ClinicLocalTime-module__m-l-8___j0oMD`,
	"mL10": `ClinicLocalTime-module__m-l-10___KfByI`,
	"mL16": `ClinicLocalTime-module__m-l-16___NBmbu`,
	"mL20": `ClinicLocalTime-module__m-l-20___jaY_u`,
	"mL24": `ClinicLocalTime-module__m-l-24___Dm7ou`,
	"mL30": `ClinicLocalTime-module__m-l-30___j5qhi`,
	"mL35": `ClinicLocalTime-module__m-l-35___qR4Ra`,
	"mL40": `ClinicLocalTime-module__m-l-40___LLWd1`,
	"mR8": `ClinicLocalTime-module__m-r-8___D5Ibr`,
	"mR10": `ClinicLocalTime-module__m-r-10___zDdJ5`,
	"mR16": `ClinicLocalTime-module__m-r-16___fP8SK`,
	"mR20": `ClinicLocalTime-module__m-r-20___jt297`,
	"mR24": `ClinicLocalTime-module__m-r-24____LfMW`,
	"mR30": `ClinicLocalTime-module__m-r-30___tC0JM`,
	"mR40": `ClinicLocalTime-module__m-r-40___rfx8z`,
	"borderR3": `ClinicLocalTime-module__border-r-3___fSflc`,
	"borderR4": `ClinicLocalTime-module__border-r-4___DiWQH`,
	"borderR6": `ClinicLocalTime-module__border-r-6___n3oF_`,
	"borderR10": `ClinicLocalTime-module__border-r-10___jMXl9`,
	"borderR12": `ClinicLocalTime-module__border-r-12___MvmiR`,
	"borderR16": `ClinicLocalTime-module__border-r-16___M2TZw`,
	"borderR50": `ClinicLocalTime-module__border-r-50___MHpUC`,
	"primaryBorder": `ClinicLocalTime-module__primary-border___iP5Gg`,
	"primaryBorderB": `ClinicLocalTime-module__primary-border-b___pLx6R`,
	"primaryBorderT": `ClinicLocalTime-module__primary-border-t___iwVD8`,
	"primaryBorderL": `ClinicLocalTime-module__primary-border-l___xmcJg`,
	"primaryBorderR": `ClinicLocalTime-module__primary-border-r___Ot7Uh`,
	"secondaryBorder": `ClinicLocalTime-module__secondary-border___XXtbY`,
	"secondaryBorderB": `ClinicLocalTime-module__secondary-border-b___x4xpJ`,
	"secondaryBorderT": `ClinicLocalTime-module__secondary-border-t___d9Uxf`,
	"secondaryBorderL": `ClinicLocalTime-module__secondary-border-l___BlQ5Z`,
	"secondaryBorderR": `ClinicLocalTime-module__secondary-border-r___sX8HG`,
	"gap0": `ClinicLocalTime-module__gap-0___j3W5f`,
	"gap2": `ClinicLocalTime-module__gap-2___i9kYn`,
	"gap4": `ClinicLocalTime-module__gap-4___IfuGn`,
	"gap5": `ClinicLocalTime-module__gap-5___D4B_C`,
	"gap6": `ClinicLocalTime-module__gap-6___I1Pdw`,
	"gap8": `ClinicLocalTime-module__gap-8___A54f6`,
	"gap10": `ClinicLocalTime-module__gap-10___p9GAa`,
	"gap12": `ClinicLocalTime-module__gap-12___Tt_h5`,
	"gap14": `ClinicLocalTime-module__gap-14___SmxLi`,
	"gap16": `ClinicLocalTime-module__gap-16___D9lyp`,
	"gap18": `ClinicLocalTime-module__gap-18___n0hGa`,
	"gap20": `ClinicLocalTime-module__gap-20___TGKpF`,
	"gap24": `ClinicLocalTime-module__gap-24___TF35N`,
	"gap26": `ClinicLocalTime-module__gap-26___F5Y9s`,
	"gap30": `ClinicLocalTime-module__gap-30___XFd0t`,
	"gap32": `ClinicLocalTime-module__gap-32___YLvOW`,
	"gap40": `ClinicLocalTime-module__gap-40___flTno`,
	"gap50": `ClinicLocalTime-module__gap-50___QrT_P`,
	"flex1": `ClinicLocalTime-module__flex-1___J4r89`,
	"flexNone": `ClinicLocalTime-module__flex-none____plhT`,
	"flexColumn": `ClinicLocalTime-module__flex-column___CAaml`,
	"flexRow": `ClinicLocalTime-module__flex-row____yWwi`,
	"verticallyCentered": `ClinicLocalTime-module__vertically-centered___N36H9`,
	"horizontallyCentered": `ClinicLocalTime-module__horizontally-centered___yOgTl`,
	"horizontallyEnd": `ClinicLocalTime-module__horizontally-end___pdoBw`,
	"verticallyStart": `ClinicLocalTime-module__vertically-start___e8_S4`,
	"spaceBetween": `ClinicLocalTime-module__space-between___ePX6P`,
	"flexWrap": `ClinicLocalTime-module__flex-wrap___LIvwe`,
	"height100": `ClinicLocalTime-module__height-100___n3IXE`,
	"width50": `ClinicLocalTime-module__width-50___bNjO8`,
	"width100": `ClinicLocalTime-module__width-100___fKm6I`,
	"cursorPointer": `ClinicLocalTime-module__cursor-pointer___Qisji`,
	"cursorNotAllowed": `ClinicLocalTime-module__cursor-not-allowed___KgdaI`,
	"absoluteCentered": `ClinicLocalTime-module__absolute-centered___lhiNx`,
	"absolute": `ClinicLocalTime-module__absolute___Rnd22`,
	"relative": `ClinicLocalTime-module__relative___N_4pw`,
	"fixed": `ClinicLocalTime-module__fixed___gKyz8`,
	"visible": `ClinicLocalTime-module__visible___QWROt`,
	"invisible": `ClinicLocalTime-module__invisible___puo3L`,
	"col90": `ClinicLocalTime-module__col-90___aUvBf`,
	"colAuto": `ClinicLocalTime-module__col-auto___t_HEK`,
	"medicalTabs": `ClinicLocalTime-module__medical-tabs___O1AGt`,
	"medicalTableNew": `ClinicLocalTime-module__medical-table-new___b0ioy`,
	"noPagination": `ClinicLocalTime-module__no-pagination___WirEw`,
	"medicalTableEmpty": `ClinicLocalTime-module__medical-table-empty___f17aE`,
	"iconBtn": `ClinicLocalTime-module__icon-btn___gKKTR`,
	"searchIcon": `ClinicLocalTime-module__search-icon___vrH7q`,
	"disableSelect": `ClinicLocalTime-module__disable-select___Ls5H6`,
	"breakWord": `ClinicLocalTime-module__break-word___zDXmF`,
	"popupClearBtn": `ClinicLocalTime-module__popup-clear-btn___yK7Ud`,
	"scrollMB20": `ClinicLocalTime-module__scroll-m-b-20___Ut0NO`,
	"clinicLocal": `ClinicLocalTime-module__clinicLocal___f42up`,
	"localLabel": `ClinicLocalTime-module__localLabel___qpWm8`,
	"localTime": `ClinicLocalTime-module__localTime___M0RGv`,
	"compact": `ClinicLocalTime-module__compact___n9LfR`
};
module.exports = ___CSS_LOADER_EXPORT___;
